import { jsx as _jsx } from "react/jsx-runtime";
import { boxStyle, normalizeStyle } from '../Box/Box';
// Keys belonging to BoxProps that must be intercepted before forwarding props
// to the DOM. Mirrors the BoxProps shape; keep in sync if BoxProps grows.
const BOX_PROP_KEYS = new Set([
    'p', 'px', 'py', 'pt', 'pr', 'pb', 'pl',
    'm', 'mx', 'my', 'mt', 'mr', 'mb', 'ml',
    'ps', 'pe', 'ms', 'me', 'pbs', 'pbe', 'mbs', 'mbe',
    'rounded', 'shadow', 'border', 'bg', 'color',
]);
function splitBoxProps(props) {
    const boxProps = {};
    const rest = {};
    for (const k of Object.keys(props)) {
        (BOX_PROP_KEYS.has(k) ? boxProps : rest)[k] = props[k];
    }
    return { boxProps: boxProps, rest };
}
function gapValue(key) {
    if (key == null)
        return undefined;
    return `var(--space-${key})`;
}
export function Row({ as: Tag = 'div', gap, rowGap, columnGap, align, justify, wrap, children, className, style: extraStyle, ...rest }) {
    const { boxProps, rest: domProps } = splitBoxProps(rest);
    // Emit gap as rowGap/columnGap longhand to keep style serialization
    // deterministic across SSR + hydration. See Box.tsx normalizeStyle for why.
    // Axis-specific props override the matching axis of `gap` when both are set.
    const baseGap = gapValue(gap);
    const rg = gapValue(rowGap) ?? baseGap;
    const cg = gapValue(columnGap) ?? baseGap;
    const style = {
        display: 'flex',
        flexDirection: 'row',
        ...(rg != null ? { rowGap: rg } : {}),
        ...(cg != null ? { columnGap: cg } : {}),
        ...(align ? { alignItems: align } : {}),
        ...(justify ? { justifyContent: justify } : {}),
        flexWrap: wrap ? 'wrap' : 'nowrap',
        minWidth: 0,
        ...boxStyle(boxProps),
        ...normalizeStyle(extraStyle),
    };
    return (_jsx(Tag, { className: className, style: style, ...domProps, children: children }));
}
//# sourceMappingURL=Row.js.map